import { type Researcher } from '@aphp-ema/common/researchers';
import { useGetIdentity } from '@refinedev/core';
import { type Auth0User } from '@/core/auth';

export const useIsEditingSelf = (userBeingEdited?: Researcher) => {
  const { data: identity } = useGetIdentity<Auth0User>();

  return (
    identity !== undefined &&
    userBeingEdited !== undefined &&
    identity.sub === userBeingEdited.auth0Id
  );
};
